import React from "react";

const Alert = (props) => {
    return (
        <div className="fixed top-0 left-0 flex justify-center items-center w-svw h-svh bg-black/50 z-50">
            <div className="flex flex-col p-6 gap-6 w-[600px] rounded-[12px] bg-white ">
                {props.children}
            </div>
        </div>
    );
}

// const Alert = (props) => {
//     return (
//         <div className="fixed top-0 flex justify-center items-center w-svw h-svh bg-black/50 z-50">
//             <div className="flex flex-col rounded-[12px] bg-white p-6 gap-24">
//                 <div className="">
//                     <img src={props.icon} alt="alert icon"/>
//                     <h5 className="font-[24px] text-black">{props.title}</h5>
//                 </div>
//                 <p>{props.question}</p>
//                 <p>{props.description}</p>
//                 <button onClick={props.onClose} className="text-2xl text-black">Cancelar</button>
//                 <button onClick={props.onConfirm} className="text-2xl text-white">Aceptar</button>
//             </div>
//         </div>
//     );
// }

export { Alert };